/** iOS Safari/WebView auto-zooms focused inputs below 16px — keep touch fields at 16px+. */
export const MOBILE_INPUT_FONT_SIZE = '16px';

const MOBILE_INPUT_ZOOM_FIX_SELECTOR = [
  '.mobile-app-shell input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="hidden"])',
  '.mobile-app-shell textarea',
  '.mobile-app-shell select',
  '.mobile-app-shell .MuiInputBase-input',
  '.mobile-app-shell .MuiSelect-select',
  '.mobile-shell-theme input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="hidden"])',
  '.mobile-shell-theme textarea',
  '.mobile-shell-theme select',
  '.mobile-shell-theme .MuiInputBase-input',
  '.mobile-shell-theme .MuiSelect-select',
  '.capacitor-native input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="hidden"])',
  '.capacitor-native textarea',
  '.capacitor-native select',
  '.capacitor-native .MuiInputBase-input',
  '.capacitor-native .MuiSelect-select',
].join(', ');

const mobileInputFontRules = {
  fontSize: MOBILE_INPUT_FONT_SIZE,
  lineHeight: '1.4',
};

export function buildMobileInputZoomFixOverrides() {
  const inputFont = mobileInputFontRules;

  return {
    MuiCssBaseline: {
      styleOverrides: {
        [MOBILE_INPUT_ZOOM_FIX_SELECTOR]: {
          fontSize: `${MOBILE_INPUT_FONT_SIZE} !important`,
          lineHeight: '1.4 !important',
        },
        '.mobile-app-shell .MuiInputBase-sizeSmall, .mobile-shell-theme .MuiInputBase-sizeSmall, .capacitor-native .MuiInputBase-sizeSmall': {
          fontSize: `${MOBILE_INPUT_FONT_SIZE} !important`,
        },
        '.mobile-app-shell .MuiInputBase-sizeSmall input, .mobile-shell-theme .MuiInputBase-sizeSmall input, .capacitor-native .MuiInputBase-sizeSmall input': {
          fontSize: `${MOBILE_INPUT_FONT_SIZE} !important`,
        },
        'html.mobile-keyboard-open, html.mobile-keyboard-open body': {
          overflow: 'hidden',
          overscrollBehavior: 'none',
        },
        '.mobile-keyboard-open .MuiDialog-container': {
          alignItems: 'center',
          justifyContent: 'center',
        },
        '.mobile-keyboard-open .MuiDialog-paper': {
          maxHeight: 'calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px) - 24px)',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: inputFont,
        root: {
          ...inputFont,
          '&.MuiInputBase-sizeSmall': {
            ...inputFont,
            '& input, & textarea': inputFont,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: inputFont,
        root: {
          ...inputFont,
          '& input, & textarea': inputFont,
          '&.MuiInputBase-sizeSmall': {
            ...inputFont,
            '& input, & textarea': inputFont,
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        input: inputFont,
        root: {
          ...inputFont,
          '& input, & textarea': inputFont,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: inputFont,
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        input: inputFont,
        inputRoot: {
          ...inputFont,
          '& .MuiInputBase-input': inputFont,
        },
      },
    },
  };
}

export function getMobileInputProps(extra = {}) {
  return {
    autoComplete: extra.autoComplete,
    inputMode: extra.inputMode,
    enterKeyHint: extra.enterKeyHint,
    style: {
      fontSize: MOBILE_INPUT_FONT_SIZE,
      ...(extra.style || {}),
    },
  };
}
